// @ts-strict-ignore
import { TextStyle } from '@coast/schemas';
import React, { useContext } from 'react';
import { View } from '@shared/components/View';
import { ColorThemeContext } from '@shared/styles';
import { AddressValue } from '../../types';
import { getTypoComponent } from '../../utils';
import { GeolocationMapPreview } from '../inputGeolocation/mapPreview';

interface Props {
  textStyle?: TextStyle;
  address: AddressValue;
  onClear?(): void;
}

export function AddressContent({ textStyle, address, onClear }: Props) {
  const colors = useContext(ColorThemeContext);
  const TypoComponent = getTypoComponent(textStyle);
  return (
    <>
      <View paddingBottom={0.5}>
        <TypoComponent color={colors.foregroundActive}>{address.title}</TypoComponent>
        <TypoComponent color={colors.foregroundInactive}>{address.subtitle}</TypoComponent>
      </View>
      <GeolocationMapPreview
        lat={address.coords.lat}
        lon={address.coords.lon}
        iconUrl="https://assets.coastapp.com/address-pin.png"
        onClear={onClear}
      />
    </>
  );
}
